import { render, staticRenderFns } from "./MediaObjectCreateForm.vue?vue&type=template&id=cf78f364&"
import script from "./MediaObjectCreateForm.vue?vue&type=script&lang=ts&"
export * from "./MediaObjectCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports